import TypesManagerContent from "./content/typesManager/typesManagerContent";
import { DockingPanel } from "./dockingPanel";

export class TypesManagerDockingPanel {
    private readonly panel: DockingPanel;
    private _visible: boolean;

    constructor(container: HTMLElement, onVisibilityChanged: (visibility: boolean) => void) {
        this._visible = false;

        const component = <TypesManagerContent />;

        const panelWidth = 350;
        const panelHeight = 505;

        this.panel = new DockingPanel(container, "dextall-types-manager-docking-panel", "Types Manager", component, {
            style: {
                resize: "none",
            },
            dimensionsControl: {
                preventOverlapsWithViewerToolbar: true,
                widthDimensionControl: { value: panelWidth, minValue: panelWidth },
                heightDimensionControl: { value: panelHeight, minValue: panelHeight },
                rightOffset: 4,
                topOffset: 4,
            },
        });

        this.panel.addVisibilityListener((x: boolean) => {
            this._visible = x;
            onVisibilityChanged(x);
        });
    }

    get visible() {
        return this._visible;
    }

    setVisible(visibility: boolean) {
        if (this._visible === visibility) {
            return;
        }

        this._visible = visibility;
        this.panel.setVisible(visibility);
    }

    shutdown() {
        this.panel.shutdown();
    }
}
